import type { RouteRecordRaw } from "vue-router";

export const routes: RouteRecordRaw[] = [
  {
    path: "/emails/history",
    name: "email-history",
    component: () => import("../presentation/pages/EmailHistory.vue"),
    meta: {
      action: "list",
      subject: "email_history",
      layout: "default",
    },
  },
  {
    path: "/emails/history/all",
    name: "all-email-history",
    component: () => import("../presentation/pages/AllEmailHistory.vue"),
    meta: {
      action: "list_all",
      subject: "email_history",
      layout: "default",
    },
  },
];
